import React from 'react';
import { Table } from 'antd';
import { connect } from 'dva';
import { formatPrice } from 'utils/utils.js';
import { cloneDeep } from 'lodash';
import styles from './Table.less';

@connect(({ operationChargeItemPublishChargeItemSteps, loading }) => ({
  loading: loading.effects['operationChargeItemPublishChargeItemSteps/fetchDataSource'],
  dataSource: operationChargeItemPublishChargeItemSteps.dataSource,
  pagination: operationChargeItemPublishChargeItemSteps.pagination,
  selectedRowKeys: operationChargeItemPublishChargeItemSteps.selectedRowKeys,
  selectedRows: operationChargeItemPublishChargeItemSteps.selectedRows,
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
}))
export default class Record extends React.Component {
  /**
   * 验证当前行是否可选择
   * 1.相同的appId可以选择
   * 2.选中无规格商品，有规格商品不可选
   * 3.选中有规格商品，剩余商品都不可选
   */
  static validateSelect(rowData, selectedRowData) {
    const { appId, skus } = selectedRowData;
    const { appId: _appId, skus: _skus } = rowData;

    // 被选择的当前行不参与判断
    if (rowData.commodityId === selectedRowData.commodityId) {
      return true;
    }

    if (_appId !== appId || !!skus) {
      return false;
    }

    return !_skus;
  }

  constructor(props) {
    super(props);

    this.handleQueryDetail = this.handleQueryDetail.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  handleQueryDetail(rowData) {
    const { dispatch, publishSchool } = this.props;

    dispatch({
      type: 'GoodsDetailModal/fetchGoodsDetailOperation',
      id: rowData.commodityId,
      orgId: publishSchool.key,
    });
  }

  handleSelect(record, selected) {
    let newSelectedRows = [];

    const { selectedRows } = this.props;

    if (selected) {
      newSelectedRows = cloneDeep(selectedRows);
      const existRow = selectedRows.find(row => row.commodityId === record.commodityId);
      if (!existRow) {
        newSelectedRows.push(record);
      }
    } else {
      newSelectedRows = selectedRows.filter(row => row.commodityId !== record.commodityId);
    }

    const newSelectedRowKeys = newSelectedRows.map(row => row.commodityId);

    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/saveSelectedData',
      selectedRowKeys: newSelectedRowKeys,
      selectedRows: newSelectedRows,
    });
  }

  handleSelectAll(selected, selectedRowsArg, changeRows) {
    let newSelectedRows = [];

    const { selectedRows } = this.props;

    if (selected) {
      newSelectedRows = cloneDeep(selectedRows);
      selectedRowsArg.forEach(record => {
        const existRow = selectedRows.find(row => row.commodityId === record.commodityId);
        if (!existRow) {
          newSelectedRows.push(record);
        }
      });
    } else {
      selectedRows.forEach(record => {
        const existRow = changeRows.find(row => row.commodityId === record.commodityId);
        if (!existRow) {
          newSelectedRows.push(record);
        }
      });
    }

    const newSelectedRowKeys = newSelectedRows.map(row => row.commodityId);

    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/saveSelectedData',
      selectedRowKeys: newSelectedRowKeys,
      selectedRows: newSelectedRows,
    });
  }

  handleTableChange(pagination, filters, sorter) {
    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/savePagination',
      pagination: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    if (this.props.onChange) {
      this.props.onChange(pagination, filters, sorter);
    }
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.props;
    // 选中列表的第一个数据
    const selectedData = selectedRows.length ? selectedRows[selectedRows.length - 1] : null;

    const columns = [
      {
        title: '商品号',
        dataIndex: 'commodityId',
      },
      {
        title: '商品名称',
        dataIndex: 'name',
        render: (val, rowData) => {
          return <a onClick={this.handleQueryDetail.bind(this, rowData)}>{val}</a>;
        },
      },
      {
        title: '商户名称',
        dataIndex: 'merchantName',
      },
      {
        title: '价格（元）',
        dataIndex: 'minPrice',
        render: (val, rowData) => {
          if (rowData.minPrice === rowData.maxPrice) {
            return formatPrice(val);
          }

          return `${formatPrice(rowData.minPrice)}-${formatPrice(rowData.maxPrice)}`;
        },
      },
      {
        width: 200,
        title: '规格',
        dataIndex: 'skus',
      },
    ];

    const rowSelection = {
      selectedRowKeys,
      onSelect: this.handleSelect,
      onSelectAll: this.handleSelectAll,
      // 判断当前行是否可选
      getCheckboxProps: record => ({
        disabled: selectedData === null ? false : !Record.validateSelect(record, selectedData),
      }),
    };

    const pagination = {
      showQuickJumper: true,
      showSizeChanger: true,
      current: this.props.pagination.current,
      total: this.props.pagination.total,
    };

    return (
      <div className={styles.root}>
        <Table
          rowSelection={rowSelection}
          loading={this.props.loading}
          rowKey="commodityId"
          dataSource={this.props.dataSource}
          columns={columns}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step1/Table.js